import $ from 'jquery';

export default {
    name: 'manage-protocole',
    components: {},
    props: {
        state_toggler: Number,
        consultation_id: Number,
        user_id: Number,
        evolution_id: Number,
        selected_cat_consigne: Object,
        selected_protocole: Object,
        info_patient: Object,
        info_caissier: Object
    },
    data() {
        return {
            liste_medicaments: [
                {
                    libelle: 'Pas dans la liste',
                    qte: 0,
                    id: 0,
                    prix: '',
                    forme: {}
                }
            ],
            liste_consommables: [
                {
                    libelle: 'Pas dans la liste',
                    qte: 0,
                    id: 0,
                    prix: '',
                }
            ],
            protocole_soins: {
                admission: '',
                chambre: '',
                chambre_nb_jour: '',
                observation: '',
                observation_nb_jour: '',
                cat_consigne: [],
                produits: [
                    {
                        produit: '',
                        autre_produit: '',
                        produit_qte: '',
                        mode_administration: '',
                        produit_source: '',
                        is_not_in_list_produit: false,
                        qty_has_error: false,
                        qty_error_msg: '',
                        source_list: []
                    }
                ],
                consommables: [
                    {
                        consommable: '',
                        autre_consommable: '',
                        consommable_qte: '',
                        consommable_source: '',
                        is_not_in_list_consommable: false,
                        qty_has_error: false,
                        qty_error_msg: '',
                        source_list: []
                    }
                ],
                actes: [
                    {
                        acte: '',
                        acte_nombre_fois: ''
                    }
                ]
            },
            cat_consigne: {
                hn: { libelle: '' },
                consigne: ''
            },

            protocole_a_suivre: [],

            admission_choice_is_empty: false,
            required_field_is_empty: false,
            chambre_loading: true,
            chambre_is_empty: false,
            observation_loading: true,
            observation_is_empty: false,

            is_cat: false,
            save_loading: false,
            data_loading: true,
            is_error: false,
            error_message: "",

            can_show_room: false,
            can_show_observation: false,
            acte_is_required: false,

            tmp_produits: [],
            tmp_consommables: [],
            tmp_actes: [],
            is_product_conflict: false,
            is_consumable_conflict: false,
            is_acte_conflict: false,
            is_cat_consigne_conflict: false,

            hn_conflict: [],
            cat_hn: [],
            is_new_cat: true,
            tmp_cat_hn: [],

            is_editing_cat: false,
            del_loading: false,
            is_confirm: false,
            permission_is_denied: false,
            patient_id: ''
        }
    },

    watch: {
        state_toggler() {
            this.listeMedicament()
            this.listeConsommable()
            this.loadObservation()
            this.loadRoom()

            // Source Pharmacie
            this.listeSourcePharmacie(0)
            this.error_message = ''
        },

        selected_cat_consigne() {
            this.is_error = false
            if (this.selected_cat_consigne.cat_consigne_en) {
                this.is_editing_cat = true

                this.cat_consigne = {
                    hn: { libelle: this.selected_cat_consigne.cat_consigne_en },
                    consigne: this.selected_cat_consigne.description
                }
            } else {
                this.is_editing_cat = false
                this.cat_consigne = {
                    hn: { libelle: '' },
                    consigne: ''
                }

                this.cat_hn = []
                let tmp_hn = []
                const selected_prot_hn = this.selected_protocole.protocoles_a_suivre 
                selected_prot_hn.forEach(prot_hn => {
                    prot_hn.prot_a_suivre.forEach(hn => {
                        tmp_hn.push(hn.protocole_hn)
                    });
                });
                
                tmp_hn.sort((a, b) => a - b)  // Order ASC

                tmp_hn = tmp_hn.filter((item, index) => tmp_hn.indexOf(item) === index)     // DISTINCT
                
                // Pré remplir les Hn déjà ajouté de sorte à ne pas avoir un duplicat lors de l'ajout des consignes
                this.selected_protocole.cat_consignes.forEach(cat_hn => {
                    this.tmp_cat_hn.push(cat_hn.cat_consigne_en)
                });

                tmp_hn.forEach(el => {
                    const cat_h = {
                        libelle: 'H'+el
                    }
                    this.cat_hn.push(cat_h)
                });
                this.cat_hn.unshift({
                    libelle: "Général"
                })
            }
        }
    },

    computed: {
        tarif_hospitalisations() {
            return this.$store.getters["tarif_hospitalisations"];
        },

        liste_adimissions() {
            return this.$store.getters["liste_adimissions"];
        },

        liste_chambres() {
            return this.$store.getters["liste_chambres"];
        },

        liste_observations() {
            return this.$store.getters["liste_observations"];
        },

        medicaments_disponibles() {
            return this.$store.getters["medicaments_disponibles"];
        },

        consommables_disponibles() {
            return this.$store.getters["consommables_disponibles"];
        },

        liste_mode_administration() {
            return this.$store.getters['liste_mode_administration'];
        },

        tarif_actes() {
            return this.$store.getters["tarif_actes"];
        },

        liste_type_mix_datas() {
            return this.$store.getters["liste_type_mix_datas"];
        }
    },

    mounted() {
        // Liste des chambres d'hospitalisation
        this.$store.dispatch("getTarifTypeAdmission", 'chambre')

        // Liste admission 
        this.$store.dispatch("getListeTypeAdmission", 'admission')

        // Mode d'administration
        this.$store.dispatch('getListeModeAdministration')

        // Liste Acte
        this.$store.dispatch('getTarifActes', 'acte')

        this.patient_id = this.$route.params.id
    },

    methods: {
        loadRoom() {
            this.chambre_loading = true

            this.$store.dispatch("getListeTypeAdmission", 'chambre').then(() => {
                if (this.liste_chambres.length == 0) {
                    this.chambre_is_empty = true
                } else {
                    this.chambre_is_empty = false
                }
                this.chambre_loading = false
            })
        },

        loadObservation() {
            this.observation_loading = true

            this.$store.dispatch("getListeTypeAdmission", 'observation').then(() => {
                if (this.liste_observations.length == 0) {
                    this.observation_is_empty = true
                } else {
                    this.observation_is_empty = false
                }
                this.observation_loading = false
            })
        },

        onChoiceAdmission() {
            this.clearError()
            this.liste_adimissions.forEach(admission => {
                if (admission.admission_id === this.protocole_soins.admission.admission_id) {
                    console.log(admission);
                    if (admission.is_with_room === 1) {
                        this.can_show_room = true
                    } else {
                        this.can_show_room = false
                    }

                    if (admission.is_with_observation === 1) {
                        this.can_show_observation = true
                    } else {
                        this.can_show_observation = false
                    }

                    if (admission.facturation_acte_id > 0) {
                        this.acte_is_required = true
                    } else {
                        this.acte_is_required = false
                    }
                }
            });
        },

        listeSourcePharmacie(index) {
            this.$store.dispatch('getListeTypeMixData', 'source_pharmacie').then(() => {
                if (this.protocole_soins.produits[index]) {
                    this.protocole_soins.produits[index].source_list = [...this.liste_type_mix_datas]
                }

                if (this.protocole_soins.consommables[index]) {
                    this.protocole_soins.consommables[index].source_list = [...this.liste_type_mix_datas]
                }
                this.data_loading = false
            })
        },

        listeMedicament() {
            this.liste_medicaments = []
            this.liste_medicaments = [
                {
                    libelle: 'Pas dans la liste',
                    qte: 0,
                    id: 0,
                    prix: '',
                    forme: {}
                }
            ]
            this.$store.dispatch("getListeMedicamentDisponible").then(() => {
                if (this.medicaments_disponibles.length > 0) {
                    this.liste_medicaments = [...this.liste_medicaments, ...this.medicaments_disponibles]
                }
            })
        },

        listeConsommable() {
            this.liste_consommables = []
            this.liste_consommables = [
                {
                    libelle: 'Pas dans la liste',
                    qte: 0,
                    id: 0,
                    prix: '',
                }
            ]
            this.$store.dispatch("getListeConsommableDisponible").then(() => {
                if (this.consommables_disponibles.length > 0) {
                    this.liste_consommables = [...this.liste_consommables, ...this.consommables_disponibles]
                }
            })
        },

        onMedicamentChange(index) {
            // Check if list of chosen products contain distinct element
            const is_not_distinct = this.handleConflictInList(this.tmp_produits, this.protocole_soins.produits[index].produit.id)
           
            if (is_not_distinct) {
                this.removeElement(this.protocole_soins.produits, index)
                this.is_product_conflict = true
                return; 
            }

            if (this.protocole_soins.produits[index].produit.id === 0) {
                this.protocole_soins.produits[index].is_not_in_list_produit = true

                this.protocole_soins.produits[index].produit_source = ''
                this.protocole_soins.produits[index].source_list.shift()
            } else {
                this.protocole_soins.produits[index].is_not_in_list_produit = false
                this.protocole_soins.produits[index].produit_source = ''
                // Source Pharmacie
                this.listeSourcePharmacie(index)
            }

            if (this.protocole_soins.produits[index].produit.id > 0) {
                // Fill Protocole a suivre
                this.fillProtocoleAsuivre(index)
            }
        },

        /**
         * Check if list of chosen products are distinct to one another
         * @param array tmp_arr
         * @param number item_id
         * @return boolean True if exist else false
         */
        handleConflictInList(tmp_arr, item_id) {
            return tmp_arr.some(tmp_item_id => tmp_item_id == item_id)
        },

        fillProtocoleAsuivre(index) {
            const libelle = (this.protocole_soins.produits[index].produit.id == 0)?this.protocole_soins.produits[index].autre_produit:this.protocole_soins.produits[index].produit.libelle
            const prot = {
                medicament: libelle,
                medicament_id: this.protocole_soins.produits[index].produit.id,
                protocole_hn: [
                    {
                        hn: '',
                        dosage: ''
                    }
                ]
            }

            if (typeof this.protocole_a_suivre[index] == 'undefined') {
                this.protocole_a_suivre.push(prot)
            } else {
                this.protocole_a_suivre[index] = prot
            }
            
        },

        onConsommableChange(index) {
            // Check if list of chosen consumable contain distinct element
            const is_not_distinct = this.handleConflictInList(this.tmp_consommables, this.protocole_soins.consommables[index].consommable.id)
           
            if (is_not_distinct) {
                this.removeElement(this.protocole_soins.consommables, index)
                this.is_consumable_conflict = true
                return; 
            }

            if (this.protocole_soins.consommables[index].consommable.id === 0) {
                this.protocole_soins.consommables[index].is_not_in_list_consommable = true

                this.protocole_soins.consommables[index].consommable_source = ''
                this.protocole_soins.consommables[index].source_list.shift()
            } else {
                this.protocole_soins.consommables[index].is_not_in_list_consommable = false
                this.protocole_soins.consommables[index].consommable_source = ''
                // Source Pharmacie
                this.listeSourcePharmacie(index)
            }
        },

        checkNumberValidity(index) {
            if (this.protocole_soins.produits[index] && this.protocole_soins.produits[index].produit == '') {
                return
            }

            if (this.protocole_soins.produits[index] &&  this.protocole_soins.produits[index].produit.id > 0) {
                
                let entry_qty = this.protocole_soins.produits[index].produit_qte
                
                entry_qty = this.transformToNumber(entry_qty)
                const toggle_qty_style = document.getElementById("med-"+index)
                const err = document.getElementById("err-invalid-"+index)
                if (isNaN(entry_qty)) {
                    if (err) {
                        err.classList.remove("is-hidden")
                    }
                    this.protocole_soins.produits[index].qty_error_msg = "Vous devez saisir un nombre"
                    if (toggle_qty_style) {
                        toggle_qty_style.classList.add("input-danger")
                    }
                }
            }
        },

        checkQtyAvailability(evolution_id, index) { 
            if (this.protocole_soins.produits[index] && this.protocole_soins.produits[index].produit == '') {
                return;
            }

            if (this.protocole_soins.produits[index] &&  this.protocole_soins.produits[index].produit.id > 0) {
                const curr_qty = this.protocole_soins.produits[index].produit.qte
                
                let entry_qty = this.protocole_soins.produits[index].produit_qte
                
                entry_qty = this.transformToNumber(entry_qty)

                const toggle_qty_style = document.getElementById("med-"+evolution_id+""+index)
                const err = document.getElementById("err-show-"+evolution_id+''+index)
                
                if (curr_qty < entry_qty)  {
                    if (err) {
                        err.classList.remove("is-hidden")
                    }
                    this.protocole_soins.produits[index].qty_error_msg = "La quantité excède le stock disponible ("+curr_qty+")"
                    
                    if (toggle_qty_style) {
                        toggle_qty_style.classList.add("input-warning")
                    }
                }
            }
        },

        checkConsommableQtyAvailability(evolution_id, index) {
            if (this.protocole_soins.consommables[index].consommable == '') {
                return
            }

            if (this.protocole_soins.consommables[index].consommable.id > 0) {
                const curr_qty = this.protocole_soins.consommables[index].consommable.qte
                
                let entry_qty = this.protocole_soins.consommables[index].consommable_qte
                
                entry_qty = this.transformToNumber(entry_qty)
                const toggle_qty_style = document.getElementById("conso-"+evolution_id+""+index)
                const err = document.getElementById("err-conso-show-"+evolution_id+""+index)
                if (curr_qty < entry_qty)  {
                    if (err) {
                        err.classList.remove("is-hidden")
                    }
                    this.protocole_soins.consommables[index].qty_error_msg = "La quantité excède le stock disponible ("+curr_qty+")"
                    
                    if (toggle_qty_style) {
                        toggle_qty_style.classList.add("input-warning")
                    }
                }
            }
        },

        clearErrorAtIndex(err_selector, qty_seletor) {
            const err = document.getElementById(err_selector)
            if (err) {
                err.classList.add("is-hidden")
            }

            const toggle_qty_style = document.getElementById(qty_seletor)
            if (toggle_qty_style) {
                toggle_qty_style.classList.remove("input-warning")
            }
        },

        clearError() {
            this.is_product_conflict = false
            this.is_consumable_conflict = false
            this.is_acte_conflict = false
            this.required_field_is_empty = false
            this.admission_choice_is_empty = false
            this.is_cat_consigne_conflict = false
            $('.err-msg').fadeOut()
        },

        reinitTmpProduit() {
            this.tmp_produits = []
            this.protocole_soins.produits.forEach(prod => {
                if (prod.produit.id > 0) {
                    this.tmp_produits.push(prod.produit.id)
                }
            });
        },

        reinitTmpConsommable() {
            this.tmp_consommables = []
            this.protocole_soins.consommables.forEach(conso => {
                if (conso.consommable.id > 0) {
                    this.tmp_consommables.push(conso.consommable.id)
                }
            });
        },

        reinitTmpActe() {
            this.tmp_actes = []
            this.protocole_soins.actes.forEach(acte => {
                if (acte.acte.id > 0) {
                    this.tmp_actes.push(acte.acte.id)
                }
            });
        },

        addProduit() {
            this.is_product_conflict = false
            /**
             * Check if a product is chosen before adding next one
             */
            let one_is_empty = false
            this.protocole_soins.produits.forEach(prod => {
                if (prod.produit === '') {
                    one_is_empty = true
                }
            });
            if (one_is_empty) {
                return;
            }

            this.reinitTmpProduit()

            this.protocole_soins.produits.push(
                {
                    produit: '',
                    autre_produit: '',
                    produit_qte: '',
                    mode_administration: '',
                    produit_source: '',
                    is_not_in_list_produit: false,
                    qty_has_error: false,
                    qty_error_msg: '',
                    source_list: [...this.liste_type_mix_datas]
                }
            )
        },

        addConsommable() {
            this.is_consumable_conflict = false
            let one_is_empty = false
            this.protocole_soins.consommables.forEach(consommable => {
                if (consommable.consommable === '') {
                    one_is_empty = true
                }
            });
            if (one_is_empty) {
                return
            }
            
            this.reinitTmpConsommable()

            this.protocole_soins.consommables.push(
                {
                    consommable: '',
                    autre_consommable: '',
                    consommable_qte: '',
                    consommable_source: '',
                    is_not_in_list_consommable: false,
                    qty_has_error: false,
                    qty_error_msg: '',
                    source_list: [...this.liste_type_mix_datas]
                }
            )
        },

        addActe() {
            this.is_acte_conflict = false

            let one_is_empty = false
            this.protocole_soins.actes.forEach(acte => {
                if (acte.acte === '') {
                    one_is_empty = true
                }
            });
            if (one_is_empty) {
                return
            }

            this.reinitTmpActe()

            this.protocole_soins.actes.push(
                {
                    acte: '',
                    acte_nombre_fois: '' 
                }
            )
        },

        addHn(index) {
            let one_is_empty = false
            this.protocole_a_suivre[index].protocole_hn.forEach(prot_hn => {
                if (prot_hn.hn === '') {
                    one_is_empty = true
                }
            });
            if (one_is_empty) {
                return
            }

            this.protocole_a_suivre[index].protocole_hn.push(
                {
                    hn: '',
                    dosage: ''
                }
            )
        },

        onActeChange(index) {
            // Check if list of chosen acte contain distinct element
            const is_not_distinct = this.handleConflictInList(this.tmp_actes, this.protocole_soins.actes[index].acte.id)
           
            if (is_not_distinct) {
                this.removeElement(this.protocole_soins.actes, index)
                this.is_acte_conflict = true
                return; 
            }
        },

        removeElement(obj, index) {
            obj.splice(index, 1)
        },

        addConsigneCAT() {
            this.cat_hn = []
            let tmp_hn = []
            this.protocole_a_suivre.forEach(prot => {
                prot.protocole_hn.forEach(h => {
                    tmp_hn.push(h.hn)
                })
            })
            tmp_hn.sort((a, b) => a - b)

            tmp_hn = tmp_hn.filter((item, index) => tmp_hn.indexOf(item) === index)

            tmp_hn.forEach(el => {
                const cat_h = {
                    libelle: 'H'+el
                }
                this.cat_hn.push(cat_h)
            });
            this.cat_hn.unshift({
                libelle: "Général"
            })

            this.is_cat = true

            // --------
            this.initCATHn()
        },

        removeCatConsigne(data) {
            const hn_to_delete = 'H'+data.hn

            this.protocole_soins.cat_consigne.forEach((cat, index) => {
                if (cat.hn == hn_to_delete) {
                    this.removeElement(this.protocole_soins.cat_consigne, index)
                }
            });
        },

        initCATHn() {
            this.is_cat_consigne_conflict = false
            this.protocole_soins.cat_consigne.forEach(cat => {
                this.tmp_cat_hn.push(cat.hn)
            });
        },

        fillCatConsigneToEdit(data) {
            this.is_new_cat = false
            this.cat_consigne = {
                hn: {
                    libelle: data.hn
                },
                consigne: data.consigne
            }
        },

        backToProtocole() {
            this.is_cat = false
        },


        handleHnConflict() {
            let is_conflict = false
            this.protocole_a_suivre.forEach((prot, index) => {
                const _set = new Set()
                if (prot.protocole_hn.some((object) => _set.size === (_set.add(object.hn), _set.size))) {
                    is_conflict = true

                    const hn_err = document.getElementById("hn-"+this.evolution_id+index+_set.size)
                    if (hn_err) {
                        hn_err.classList.add("input-danger")
                    }
                    this.hn_conflict[index] = true
                }
            });
            return is_conflict
        },

        clearProtHnError(evolution_id, prot_i, hn_i) {
            this.hn_conflict[prot_i] = false
            const hn_err = document.getElementById("hn-"+evolution_id+prot_i+hn_i)
            if (hn_err) {
                hn_err.classList.remove("input-danger")
            }
        },

        async submit(evolution_id) {
            this.is_error = false
            this.required_field_is_empty = false
            if (this.protocole_soins.admission == '') {
                this.required_field_is_empty = true
                this.admission_choice_is_empty = true
                const f = document.getElementById('adm-err'+evolution_id)
                if (f) {
                    f.focus()
                }
                return;
            } 
            
            const isValid = await this.$refs.prot_form.validate();
            if (!isValid) {
                this.required_field_is_empty = true
                return;
            }

            // Check if Protocole a suivre is filled
            if (this.protocole_soins.produits[0].produit_qte != '' && this.protocole_a_suivre.length === 0) {
                return
            }

            if (this.handleHnConflict()) {
                return
            }
            
            this.protocole_soins.protocole_a_suivre = this.protocole_a_suivre
            this.protocole_soins.protocole_id = 0
            this.protocole_soins.user_id = this.user_id
            this.protocole_soins.evolution_id = this.evolution_id
            this.protocole_soins.consultation_id = this.consultation_id
            this.protocole_soins.patient_id = this.patient_id
            this.protocole_soins.can_set_pac = this.can_set_pac
            this.protocole_soins.info_patient =  this.info_patient
            this.protocole_soins.info_caissier =  this.info_caissier
            
            this.save_loading = true
            this.$store.dispatch('saveConsultationProtocoleSoins', this.protocole_soins).then((response) => {
                if (response.success) {
                    this.successToast('Protocole enregistré avec succès')
                    this.$emit('emitProtocoleSoins')

                    this.protocole_soins = {
                        admission: '',
                        chambre: '',
                        chambre_nb_jour: '',
                        observation: '',
                        observation_nb_jour: '',
                        cat_consigne: [],
                        produits: [
                            {
                                produit: '',
                                autre_produit: '',
                                produit_qte: '',
                                mode_administration: '',
                                produit_source: '',
                                is_not_in_list_produit: false,
                                qty_has_error: false,
                                qty_error_msg: '',
                                source_list: []
                            }
                        ],
                        consommables: [
                            {
                                consommable: '',
                                autre_consommable: '',
                                consommable_qte: '',
                                consommable_source: '',
                                is_not_in_list_consommable: false,
                                qty_has_error: false,
                                qty_error_msg: '',
                                source_list: []
                            }
                        ],
                        actes: [
                            {
                                acte: '',
                                acte_nombre_fois: ''
                            }
                        ]
                    }
                    this.protocole_a_suivre = []
                    this.cat_consigne = {
                        hn: { libelle: '' },
                        consigne: ''
                    }
                    this.$refs.prot_form.reset()

                    this.$refs.prot_mdl.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        }, 

        async saveConsigne() {
            const isValid = await this.$refs.cat_form.validate();
            if (!isValid) {
                return;
            }

            /**
             * Check if duplicate entry exist in CAT / Consigne
             */
            this.is_cat_consigne_conflict = this.handleConflictInList(this.tmp_cat_hn, this.cat_consigne.hn.libelle)
            if (this.is_new_cat && this.is_cat_consigne_conflict) {
                return;
            }

            if (!this.is_new_cat) {
                this.protocole_soins.cat_consigne.forEach(cat => {
                    if (cat.hn == this.cat_consigne.hn.libelle) {
                        cat.consigne = this.cat_consigne.consigne
                    }
                });
            } else {
                this.protocole_soins.cat_consigne.push({
                    hn: this.cat_consigne.hn.libelle,
                    consigne: this.cat_consigne.consigne
                })
            }
            
            this.cat_consigne = {
                hn: { libelle: '' },
                consigne: ''
            }
            this.$refs.cat_form.reset()
            this.is_new_cat = true
            this.backToProtocole()
            
        },

        /**
         * Add or Update Cat / Consigne
         */
        async saveCATConsigne() {
            const isValid = await this.$refs.edit_cat_form.validate();
            if (!isValid) {
                return;
            }

            /**
             * Check if duplicate entry exist in CAT / Consigne
             */
            if (!this.is_editing_cat) {
                this.is_cat_consigne_conflict = this.handleConflictInList(this.tmp_cat_hn, this.cat_consigne.hn.libelle)
                if (this.is_new_cat && this.is_cat_consigne_conflict) {
                    return;
                }
            }

            let data = {}
            if (this.is_editing_cat) {
                data = {
                    consultation_id: this.consultation_id,
                    evolution_id: this.selected_protocole.evolution_id,
                    user_id: this.user_id,
                    protocole_id: this.selected_protocole.protocole_id,
                    cat_id: this.selected_cat_consigne.cat_id,
                    hn: this.cat_consigne.hn.libelle,
                    consigne: this.cat_consigne.consigne
                }
            } else {
                data = {
                    consultation_id: this.consultation_id,
                    evolution_id: this.selected_protocole.evolution_id,
                    user_id: this.user_id,
                    protocole_id: this.selected_protocole.protocole_id,
                    cat_id: this.selected_cat_consigne.cat_id,
                    hn: this.cat_consigne.hn.libelle,
                    consigne: this.cat_consigne.consigne
                }
            }

            this.save_loading = true
            this.$store.dispatch('saveConsultationCatConsigne', data).then((response) => {
                if (response.success) {
                    this.successToast('Enregistrement effectué avec succès')
                    this.$emit('emitProtocoleSoins')

                    this.$refs.cat_mdl.click()
                    this.$refs.edit_cat_form.reset()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    } else if (response.code === 409) {
                        this.error_message = "Consigne déjà ajoutée en l'H choisi !"
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Supprimer une CAT/Consigne
		 */
        deleteCAT(selector) {
            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            const data = {
                consultation_id: this.consultation_id,
                evolution_id: this.selected_protocole.evolution_id,
                cat_id: this.selected_cat_consigne.cat_id,
                protocole_id: this.selected_protocole.protocole_id,
                user_id: this.user_id
            }
            
            this.$store.dispatch('deleteConsultationCatConsigne', data).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit('emitProtocoleSoins')

                    this.$refs.del_cat.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },

        deleteProtocoleSoins(selector) {
            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            const data = {
                consultation_id: this.consultation_id,
                evolution_id: this.selected_protocole.evolution_id,
                protocole_id: this.selected_protocole.protocole_id,
                user_id: this.user_id
            }
            
            this.$store.dispatch('deleteProtocoleSoins', data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.$emit('emitProtocoleSoins')

                    this.$refs.del_prot_soins.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = response.message
                    } else if (response.code === 500) {
                        this.error_message = response.message
                    }
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        }
    }
}


